import { LOCALES, LOCALES_TITLES } from "constants/languages";

export const localesOptions = [
  { code: LOCALES.english, label: LOCALES_TITLES.english },
  { code: LOCALES.swedish, label: LOCALES_TITLES.swedish },
  { code: LOCALES.norwegian, label: LOCALES_TITLES.norwegian },
];
